import { useActive, useCommands } from '@remirror/react-core';
import { CodeOutlined } from '@ant-design/icons';
import CommandButton from '../CommandButton';
import React, { useCallback } from 'react';

export const CodeButton = React.memo(() => {
  const { toggleCode } = useCommands();

  const handleSelect = useCallback(() => {
    if (toggleCode.enabled()) {
      toggleCode();
    }
  }, [toggleCode]);

  const active = useActive().code();
  const enabled = toggleCode.enabled();

  return (
    <CommandButton
      aria-label={'Code'}
      icon={<CodeOutlined className="lg" />}
      active={active}
      enabled={enabled}
      onClick={handleSelect}
    />
  );
});

export default CodeButton;
